import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { closeDialog } from '../../../store/modules/dialog';
import Dialog from '../Dialog';
import { useTranslation } from 'react-i18next';
import OptionList from '../../common/OptionList';
import { useEffect, useRef, useState } from 'react';

import { usePOWebofficeSDKState } from '../../../context/poWebOfficeSDKContext';
import { insertActiveLink } from '../../plugin/activeLink';
import { genPWCVoting } from '../../plugin/pwc/pwcApis';
import { useGenNotificationPromise } from '../../notification/Notification';
import ActiveLinkDialogFooter from './ActiveLinkDialogFooter';

const DialogBody = styled.div`
  display: flex;
  flex-flow: column;
  width: 487px;
  height: 530px;
  padding: 24px;
`;

const TitleWrapper = styled.div`
  height: 29px;
  font-size: 20px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  margin-bottom: 24px;
`;

const ContentsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
`;

const ContentItem = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const ContentLabel = styled.div`
  width: 100%;
  height: 26px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-bottom: 6px;
`;

const InsertInput = styled.input`
  width: 100%;
  height: 44px;
  border-radius: 4px;
  border: solid 1px #c4c4c4;
  padding: 5px;
  font-size: 16px;
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
`;

export default function ActiveLinkVoteDialog({ isShow }) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const DEFAULT_KEY_VALUE = 0;
  const optKey = useRef(DEFAULT_KEY_VALUE);
  const [question, setQuestion] = useState('');
  const [formOptions, setFormOptions] = useState([{ key: DEFAULT_KEY_VALUE, value: '' }]);
  const poSDKContextState = usePOWebofficeSDKState();
  const notificationPromise = useGenNotificationPromise();

  const initLocalValue = () => {
    optKey.current = optKey.current + 1;
    setFormOptions([{ key: optKey.current, value: '' }]);
  };

  useEffect(() => {
    initLocalValue();
  }, []);

  const checkValid = () => {
    if (question && formOptions && formOptions.length > 0) {
      const checkArr = formOptions.filter((form) => !form || !form.value);
      if (checkArr.length === 0) {
        return true;
      }
    }

    return false;
  };

  const onClickSubmit = () => {
    if (checkValid()) {
      const answers = formOptions.map((op) => op.value);
      genPWCVoting({ question, answers })
        .then((pwcURL) => insertActiveLink(poSDKContextState, pwcURL))
        .then(() => {
          dispatch(closeDialog());
        });
    } else {
      notificationPromise({
        title: i18n.t('Common.Notification'),
        message: i18n.t('ActiveLink.VoteErrorMessage'),
        btn: {
          confirm: {
            text: i18n.t('Common.Confirm')
          }
        },
        showCloseBtn: false
      });
    }
  };

  return (
    <Dialog isNoHeader isShow={isShow}>
      <DialogBody>
        <TitleWrapper>{t('ActiveLink.Vote')}</TitleWrapper>
        <ContentsWrapper>
          <ContentItem>
            <ContentLabel>{t('ActiveLink.Questions')}</ContentLabel>
            <InsertInput value={question} onChange={(e) => setQuestion(e.target.value)} />
          </ContentItem>
          <ContentItem>
            <ContentLabel>{t('ActiveLink.Answers')}</ContentLabel>
            <OptionList option={{ formOptions, setFormOptions, optKey }} />
          </ContentItem>
        </ContentsWrapper>
        <ActiveLinkDialogFooter onSubmit={onClickSubmit}></ActiveLinkDialogFooter>
      </DialogBody>
    </Dialog>
  );
}
